import React, { Component } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  FormControl,
  Divider,
  Tabs,
  Tab
} from '@material-ui/core'
import Select from 'react-select'
import { withStyles } from '@material-ui/core/styles'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'

const GET_DEVICE_DETAILS = gql`
  query getAllAssignedDevicesToClient($clientId: Int!) {
    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {
      uniqueDeviceId
      deviceModel {
        model_name
      }
    }
  }
`

const GET_SIM_DETAILS = gql`
  query getAllAssignedSimToClient($clientId: Int!) {
    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {
      id
      simId
      sim {
        phoneNumber
      }
    }
  }
`

const DECOUPLE_DEVICESIM = gql`
  mutation decoupleDeviceSim(
    $newDeviceUniqueId: String
    $existingDeviceUniqueId: String
    $newSimId: Int
    $existingSimId: Int
    $decoupleType: String!
    $loginType: String!
  ) {
    decoupleDeviceSim(
      newDeviceUniqueId: $newDeviceUniqueId
      existingDeviceUniqueId: $existingDeviceUniqueId
      newSimId: $newSimId
      existingSimId: $existingSimId
      decoupleType: $decoupleType
      loginType: $loginType
    )
  }
`

const styles = theme => ({
  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%'
  },
  dialogContent: {
    height: '450px'
  },
  infoContainer: {
    backgroundColor: '#f8f9fa',
    border: '1px solid #dee2e6',
    borderRadius: '4px',
    padding: '12px 16px',
    marginBottom: '20px'
  },
  infoItem: {
    marginBottom: '8px',
    '&:last-child': {
      marginBottom: 0
    }
  }
})

class DecoupleDeviceSimDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      vehicleStatus: '',
      deviceDetails: [],
      simDetails: [],
      serialNumber: null,
      phoneNumber: null,
      deviceDecouple: false,
      simDecouple: false,
      deviceSimDecouple: false,
      response: '',
      reason: ''
    }
  }

  componentDidMount() {
    if (this.props.open) {
      this.handleChangeType({ value: 'Device' })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState({
        vehicleStatus: '',
        serialNumber: null,
        phoneNumber: null,
        response: '',
        reason: ''
      }, () => {
        this.handleChangeType({ value: 'Device' })
      })
    }
  }

  handleChangeType = async event => {
    this.setState({
      vehicleStatus: event.value,
      deviceDecouple: false,
      simDecouple: false,
      deviceSimDecouple: false
    })

    let clientLoginId = parseInt(this.props.clientLoginId, 10)

    if (event.value === 'Device') {
      const {
        data: device,
        error: deviceError
      } = await this.props.client.query({
        query: GET_DEVICE_DETAILS,
        variables: { clientId: clientLoginId },
        errorPolicy: 'all'
      })

      const allDevices = device.device.map(device => ({
        value: device.uniqueDeviceId,
        label: device.uniqueDeviceId
      }))

      if (deviceError) {
        this.setState({ deviceDetails: [] })
      } else {
        this.setState({ deviceDetails: allDevices, deviceDecouple: true })
      }
    } else if (event.value === 'Sim') {
      const {
        data: simDetails,
        error: simError
      } = await this.props.client.query({
        query: GET_SIM_DETAILS,
        variables: { clientId: clientLoginId },
        errorPolicy: 'all'
      })

      const allSims = simDetails.simDetails.map(sim => ({
        value: sim.simId,
        label: sim.sim.phoneNumber
      }))

      if (simError) {
        this.setState({ simDetails: [] })
      } else {
        this.setState({ simDetails: allSims, simDecouple: true })
      }
    } else {
      // DeviceAndSim
      const {
        data: device,
        error: deviceError
      } = await this.props.client.query({
        query: GET_DEVICE_DETAILS,
        variables: { clientId: clientLoginId },
        errorPolicy: 'all'
      })

      const allDevices = device.device.map(device => ({
        value: device.uniqueDeviceId,
        label: device.uniqueDeviceId
      }))

      const {
        data: simDetails,
        error: simError
      } = await this.props.client.query({
        query: GET_SIM_DETAILS,
        variables: { clientId: clientLoginId },
        errorPolicy: 'all'
      })

      const allSims = simDetails.simDetails.map(sim => ({
        value: sim.simId,
        label: sim.sim.phoneNumber
      }))

      if (deviceError) {
        this.setState({ deviceDetails: [] })
      } else {
        this.setState({ deviceDetails: allDevices, deviceDecouple: true })
      }

      if (simError) {
        this.setState({ simDetails: [] })
      } else {
        this.setState({ simDetails: allSims, simDecouple: true })
      }
    }
  }

  handleTabChange = (event, newValue) => {
    this.handleChangeType({ value: newValue })
  }

  handleSubmit = async event => {
    event.preventDefault()

    const { vehicleStatus, serialNumber, phoneNumber } = this.state
    const { uniqueDeviceId, simId } = this.props

    let variables = {
      decoupleType: vehicleStatus,
      loginType: localStorage.getItem('Account_type') || 'PA'
    }

    if (vehicleStatus === 'Device') {
      variables.existingDeviceUniqueId = uniqueDeviceId
      variables.newDeviceUniqueId = serialNumber
      variables.existingSimId = null
      variables.newSimId = null
    } else if (vehicleStatus === 'Sim') {
      variables.existingDeviceUniqueId = null
      variables.newDeviceUniqueId = null
      variables.existingSimId = simId
      variables.newSimId = phoneNumber
    } else if (vehicleStatus === 'DeviceAndSim') {
      variables.existingDeviceUniqueId = uniqueDeviceId
      variables.newDeviceUniqueId = serialNumber
      variables.existingSimId = simId
      variables.newSimId = phoneNumber
    }

    const { data } = await this.props.client.mutate({
      mutation: DECOUPLE_DEVICESIM,
      variables: variables,
      refetchQueries: ['getVehicleDetail']
    })

    this.setState({ response: data.decoupleDeviceSim })

    if (this.state.response === 'Success') {
      setTimeout(() => {
        this.props.onClose()
      }, 1500)
    }
  }

  handleChangeDevice = event => {
    this.setState({ serialNumber: event.value })
  }

  handleChangePhoneNumber = event => {
    this.setState({ phoneNumber: event.value })
  }

  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
  }

  render() {
    const { classes } = this.props
    const { open, onClose, solutionType, uniqueDeviceId, simPhoneNumber } = this.props
    const { vehicleStatus, response, reason } = this.state

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle id="form-dialog-title">Decouple Device/Sim</DialogTitle>

        <Tabs
          value={vehicleStatus || false}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
          style={{ borderBottom: '1px solid #e0e0e0' }}
        >
          <Tab value="Device" label="Device" />
          <Tab value="Sim" label="Sim" />
          <Tab value="DeviceAndSim" label="Device & Sim" />
        </Tabs>

        {response === 'Success' && (
          <Typography
            variant="subheading"
            gutterBottom
            style={{ color: 'green', marginLeft: '25px' }}
          >
            <p>Decoupled Successfully</p>
          </Typography>
        )}

        {response !== 'Success' && response !== '' && (
          <Typography
            variant="subheading"
            gutterBottom
            style={{ color: 'red', marginLeft: '25px' }}
          >
            <p>{response}</p>
          </Typography>
        )}

        <Divider light />

        <form onSubmit={this.handleSubmit} style={{ height: '550px' }}>
          <DialogContent className={classes.dialogContent}>
            <Typography variant="body2" style={{ marginBottom: '10px' }}>
              * Marked fields are mandatory
            </Typography>

            {/* Current Configuration Display */}
            <div className={classes.infoContainer}>
              <div className={classes.infoItem}>
                <Typography variant="caption" style={{ color: '#6c757d', marginBottom: '2px', display: 'block' }}>
                  Solution Type
                </Typography>
                <Typography variant="body2" style={{ fontWeight: '500', color: '#333' }}>
                  {solutionType || 'N/A'}
                </Typography>
              </div>
              <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                <div style={{ flex: 1 }}>
                  <Typography variant="caption" style={{ color: '#6c757d', marginBottom: '2px', display: 'block' }}>
                    Current Device ID
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: '500', color: '#333' }}>
                    {uniqueDeviceId || 'Not Assigned'}
                  </Typography>
                </div>
                <div style={{ flex: 1 }}>
                  <Typography variant="caption" style={{ color: '#6c757d', marginBottom: '2px', display: 'block' }}>
                    Current SIM Number
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: '500', color: '#333' }}>
                    {simPhoneNumber || 'Not Assigned'}
                  </Typography>
                </div>
              </div>
            </div>

            {!vehicleStatus && (
              <Typography variant="body2" style={{ textAlign: 'center', marginTop: '40px', color: '#666' }}>
                Please select a decouple type using the tabs above to proceed
              </Typography>
            )}

            {(this.state.deviceDecouple || this.state.deviceSimDecouple) && (
              <FormControl className={classes.formControl} style={{ minWidth: '100%', marginTop: '20px' }}>
                <Typography variant="subtitle2" style={{ marginBottom: '8px', color: '#555', fontWeight: 'bold' }}>
                  Select New Device *
                </Typography>
                <Select
                  options={this.state.deviceDetails}
                  value={this.state.serialNumber ? this.state.deviceDetails.find(device => device.value === this.state.serialNumber) : null}
                  onChange={this.handleChangeDevice}
                  placeholder="Choose Device ID"
                />
              </FormControl>
            )}

            {(this.state.simDecouple || this.state.deviceSimDecouple) && (
              <FormControl className={classes.formControl} style={{ minWidth: '100%', marginTop: '20px' }}>
                <Typography variant="subtitle2" style={{ marginBottom: '8px', color: '#555', fontWeight: 'bold' }}>
                  Select New SIM Number *
                </Typography>
                <Select
                  options={this.state.simDetails}
                  value={this.state.phoneNumber ? this.state.simDetails.find(sim => sim.value === this.state.phoneNumber) : null}
                  onChange={this.handleChangePhoneNumber}
                  placeholder="Choose SIM Card"
                />
              </FormControl>
            )}

            <FormControl className={classes.formControl} style={{ minWidth: '100%' }}>
              <TextField
                autoFocus
                margin="dense"
                id="reason"
                name="reason"
                label="Reason For Decouple!"
                multiline
                rows={3}
                required
                value={reason}
                fullWidth
                onChange={this.handleInputChange('reason')}
              />
            </FormControl>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={onClose}
              color="default"
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={!(vehicleStatus !== '' && reason !== '')}
            >
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

export default withStyles(styles)(withApollo(DecoupleDeviceSimDialog))



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/DecoupleDeviceSimDialog.jsx